import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import StoreSticker from "./StoreSticker";
import "./StoreStickerOverlay.css";

/**
 * StoreStickerOverlay
 *
 * Full-screen overlay that shows the store sticker with
 * download / share actions. Rendered via createPortal.
 *
 * Props:
 *  - storeName, address, category, phoneNumber, storeUrl — passed to StoreSticker
 *  - onClose {function} required
 */
export default function StoreStickerOverlay({ storeName, address, category, phoneNumber, storeUrl, onClose }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return createPortal(
    <div className='sso-backdrop' onClick={onClose}>
      <div className='sso-panel' onClick={(e) => e.stopPropagation()}>
        <div className='sso-header'>
          <span className='sso-header-title'>Store Sticker</span>
          <button type='button' className='sso-close' onClick={onClose} aria-label='Close'>
            <X size={18} strokeWidth={2} />
          </button>
        </div>

        <div className='sso-body'>
          <StoreSticker storeName={storeName} address={address} category={category} phoneNumber={phoneNumber} storeUrl={storeUrl} />
        </div>
      </div>
    </div>,
    document.body,
  );
}
